(() => {
 const reduce = matchMedia('(prefers-reduced-motion: reduce)');
 const hover = matchMedia('(hover: hover)');
 function init(root = document) {
  root.querySelectorAll('[data-card-video]').forEach(card => {
   if (card.dataset.videoReady) return;
   card.dataset.videoReady = 'true';
   const area = card.classList.contains('ca-native-card-preview') ? card.parentElement : card;
   const video = card.querySelector('video');
   const button = card.querySelector('.ca-card-video-toggle');
   if (!video || !button) return;
   let requested = false;
   const stop = () => { requested = false; video.pause(); card.classList.remove('is-playing'); button.setAttribute('aria-pressed', 'false'); button.textContent = '▶ See it in motion'; };
   const play = async () => {
    requested = true;
    const source = video.querySelector('source[data-src]');
    if (source && !source.src) { source.src = source.dataset.src; video.load(); }
    try { await video.play(); if (!requested) { video.pause(); return; } card.classList.add('is-playing'); button.setAttribute('aria-pressed', 'true'); button.textContent = 'Ⅱ Pause video'; } catch { stop(); }
   };
   area.addEventListener('pointerenter', () => { if (hover.matches && !reduce.matches) play(); });
   area.addEventListener('pointerleave', () => { if (hover.matches) stop(); });
   button.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); requested ? stop() : play(); });
   card.addEventListener('focusout', e => { if (!card.contains(e.relatedTarget)) stop(); });
   document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
   new IntersectionObserver(entries => { if (!entries[0].isIntersecting) stop(); }).observe(card);
  });
 }
 init();
 document.addEventListener('shopify:section:load', e => init(e.target));
})();
